import {sentryService} from '@/ts/services/sentry-service';
import type {SentryBreadcrumbData, SentrySeverityLevel} from '@/ts/types/sentry';

/** Contract for Sentry error tracking methods */
export interface SentryComposable {
  captureException(error: Error, context?: Record<string, unknown>): void;
  captureMessage(message: string, level?: SentrySeverityLevel): void;
  captureLog(category: string, message: string, level?: SentrySeverityLevel, data?: Record<string, unknown>): void;
  addBreadcrumb(breadcrumb: SentryBreadcrumbData): void;
  setTag(key: string, value: string): void;
}

/** Provides Sentry error tracking methods for capturing exceptions, messages, logs, breadcrumbs, and tags */
export function useSentry(): SentryComposable {
  return {
    captureException: (error: Error, context?: Record<string, unknown>): void => {
      sentryService.captureException(error, context);
    },
    captureMessage: (message: string, level?: SentrySeverityLevel): void => {
      sentryService.captureMessage(message, level);
    },
    captureLog: (
      category: string,
      message: string,
      level?: SentrySeverityLevel,
      data?: Record<string, unknown>,
    ): void => {
      sentryService.captureLog(category, message, level, data);
    },
    addBreadcrumb: (breadcrumb: SentryBreadcrumbData): void => {
      sentryService.addBreadcrumb(breadcrumb);
    },
    setTag: (key: string, value: string): void => {
      sentryService.setTag(key, value);
    },
  };
}
